const lastOpenFileByStep = new Map<string, string>();

const key = (workflowId: string, step: string) => `${workflowId}:${step}`;

export function rememberStepFile(
  workflowId: string,
  step: string | undefined,
  file: string
) {
  if (!step || !file) return;
  lastOpenFileByStep.set(key(workflowId, step), file);
}

export function recallStepFile(
  workflowId: string,
  step: string
): string | undefined {
  return lastOpenFileByStep.get(key(workflowId, step));
}

export function clearStepFiles() {
  lastOpenFileByStep.clear();
}
